import type { SiteIdent } from '~~/.nuxt/imports';

export function useSiteIdent(): SiteIdent {
  return useNuxtApp().$siteIdent as SiteIdent;
}
